<template>
  <v-container>
    <v-row
      v-if="role !== 3"
      justify="center"
    >
      <v-col
        cols="12"
        sm="10"
      >
        <v-card class="d-flex justify-sm-space-between flex-wrap">
          <v-card-title
            cols="12"
            sm="6"
          >
            Счета участника -
            <v-chip
              class="mx-5"
              color="primary"
            >
              {{ userProfile.fio }}
            </v-chip>
          </v-card-title>
          <v-btn
            cols="12"
            sm="6"
            class="ma-3"
            outlined
            color="secondary"
            @click="downloadReport"
          >
            <v-icon class="ml-3">
              mdi-download
            </v-icon>
            <span class="mx-3">Выгрузить</span>
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col
        cols="12"
        sm="10"
      >
        <base-material-card
          v-for="account in accounts"
          :key="account.account.AccountId"
        >
          <template v-slot:heading>
            <div class="text-subtitle-1 font-weight-light" />
            <div class="text-h6 font-weight-light">
              {{ account.campaign.name }}
            </div>
            <div class="info--text font-weight-light">
              {{ account.campaign.description }}
            </div>
          </template>
          <!--          <v-card-title>{{ account.campaign.name }}</v-card-title>-->
          <!--          <v-card-subtitle>{{ account.campaign.description }}</v-card-subtitle>-->
          <!--          <v-divider></v-divider>-->
          <v-card-text>
            <span
              class="blue--text text--lighten-2 ap"
            >Средств на счету -
            </span>
            <span class="blue--text text--darken-2 apb">{{
              account.account.Amount
            }}</span>
          </v-card-text>
        </base-material-card>
        <v-card v-if="role !== 3">
          <v-card-actions class="d-flex justify-space-around">
            <v-btn
              color="primary"
              outlined
              @click="$router.back()"
            >
              Назад
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WebApi from "../../shared/modules/web_api"
import { downloadCsvFile } from "@/views/loyalty/shared/modules/utilities"
// import UserProfileModel from "@/views/loyalty/models/user-profile.model"

export default {
  name: "AccountParticipantEdit",
  data: () => ({
    accounts: [],
    amount: 0,
    role: 0,
    participantId: null,
    userProfile: {},
    webApi: null
  }),
  beforeMount () {
    this.webApi = new WebApi(this.$store).readError(
        "Не удалось загрузить данные"
    )
    console.log("state", this.$store.state)
    this.role = +this.$route.params.role

    if (this.role === 3) {
      // this.userProfile = this.$store.getters[
      //   "user_profile_store/getUserProfile"
      // ].userProfile
      // console.log(`this.userProfile=${JSON.stringify(this.userProfile)}`)
      this.participantId = this.$store.state.user.id
      this.webApi
          .get(
              `${process.env.VUE_APP_LOYALTY_URL}account/participant/${this.participantId}`
          )
          .then(data => {
            if (data.status_code === 401) {
              console.error("Ошибка")
            }
            this.accounts = data
            console.log(this.accounts)
          })
    } else {
      this.participantId = this.$route.params.participant
      this.customerId = this.$store.state.user.current_client
      this.webApi
          .get(
              `${process.env.VUE_APP_LOYALTY_URL}account/customer_participant/${
                  this.customerId
              }/${this.participantId}`
          )
          .then(data => {
            if (data.status_code === 401) {
              console.error("Ошибка")
            }
            this.accounts = data
            console.log(this.accounts)
          })
    }
    // this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}user_profile/${
    //     this.participantId
    // }`).then(data => {
    //   this.userProfile = Reflect.construct(UserProfileModel, [data])
    // })

    console.log(`this.participantId=${this.participantId}`)
  },
  // mounted() {
  //
  // },
  methods: {
    downloadReport () {
      let csvContent = "ФИО;Программа лояльности;Счёт;Сумма;\n"
      const delim = ";"
      this.accounts.forEach(account => {
        csvContent +=
            this.userProfile.fio +
            delim +
            account.campaign.name +
            delim +
            account.account.Account +
            delim +
            account.account.Amount +
            delim +
            "\n"
      })
      downloadCsvFile("ParticipantAccountReport", csvContent)
    }
  }
}
</script>

<style scoped>
.ap {
  font-size: 2rem;
}

.apb {
  font-size: 2rem;
  font-weight: bold;
}
</style>
